import React from "react";
import { IonCard, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonIcon } from '@ionic/react';
import { calendarClearOutline,timeOutline } from "ionicons/icons"
import InputAddressComponent from "./InputAddressComponent"
import MapComponent from "./MapComponent";
import SummaryComponent from "./SummaryComponent"
import NavigationButton from "./NavigationButton"
import { useRecoilState, } from "recoil";

import { bookingOptions } from "../../../store/atoms/bookingDetailAtoms"

import { handleBookingOptionsSelect } from "../handler"

const AddressDetailsComponent = () => {
    const [bookingOptionsState, setBookingOptionsState] = useRecoilState(bookingOptions);
    
    return (
        <>
            <div className="tabs">
                <div className='tab-header'>
                    <div className="tab" >
                        <input type="radio" className='first-tab' checked={!bookingOptionsState.scheduledDelivery} onClick={()=>{handleBookingOptionsSelect('pickUpNow', setBookingOptionsState)}} id="tab-1" name="tab-group-1" />
                        <label htmlFor="tab-1">
                            <img src="img/picknow.svg"/>
                            <h2>Pick up now</h2>
                            <p>We will deliver within 50 minutes.</p>
                            
                        </label>
                    </div>
                    <div className="tab">
                        <input type="radio" id="tab-2" name="tab-group-1" checked={bookingOptionsState.scheduledDelivery} onClick={()=>{handleBookingOptionsSelect('scheduledDelivery', setBookingOptionsState)}}/>
                        <label htmlFor="tab-2">
                        <img src="img/pickup-later.svg"/>
                        <h2>Schedule a delivery</h2>
                            <p>We will arrive at address at your scheduled time.</p>
                        </label>
                    </div> 
                </div>
            </div>

                    <div className="content">
                        <div className="accordion-wrapper">
                        {
                        bookingOptionsState.scheduledDelivery && 
                        <IonCard className="sequel1-card-scheduler" class='ion-no-margin date-wrapper'>
                            <div className="sequel1-card-scheduler-row">
                            <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonLabel className="sequel1-label-scheduler">Select Date</IonLabel>
                                    <div className="sequel1-col-scheduler" style={{marginRight:'13px'}} >
                                        <IonInput className="sequel1-input-scheduler" type="date"/>
                                        <IonIcon className="sequel1-icon-scheduler" icon={calendarClearOutline}/>
                                    </div>
                                </IonCol>
                                <IonCol>
                                    <IonLabel className="sequel1-label-scheduler">Select Time</IonLabel>
                                    <div className="sequel1-col-scheduler">
                                        <IonInput className="sequel1-input-scheduler"  type="time"/>
                                        <IonIcon className="sequel1-icon-scheduler" icon={timeOutline}/>
                                    </div>
                                </IonCol>
                            </IonRow>
                            </IonGrid>
                            </div>
                        </IonCard>
                        }

                        <h4>Enter Address</h4>
                        <a className='import-address' >Bulk Upload</a>

                        <div className='search-wrapper'>
                            {
                                <InputAddressComponent/>
                            }
                        </div>
                    </div>
                        <MapComponent/>
                        <SummaryComponent/>
                        <NavigationButton/>
                    </div>


                
            
            
        </>
    )
}

export default AddressDetailsComponent ;